/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/member-delimiter-style */
import React, { useEffect, useState } from 'react'
import API from '@aws-amplify/api'
import Divider from '@material-ui/core/Divider'
import { ListGroup } from 'react-bootstrap'
import { makeStyles } from '@material-ui/core/styles'
import { inject, observer } from 'mobx-react'
import BarLoader from 'react-spinners/BarLoader'
import { css } from '@emotion/react'
import { Prospect } from '../../../../stores/prospects'
import Report from './Report'
import ReportActivity from './ReportActivity'
import ReportFilters from './ReportFilters'
import { ToastTypeEnum } from '../../Toasts'
import ReportEngagement from './ReportEngagement'
import './styles.scss'
import BulkLeadActions from '../../Common/BulkLeadActions'

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    width: '100%',
  },
  tabs: {
    '& .MuiTab-root': {
      flex: 1,
      minWidth: 'unset',
    },
    '& .MuiTabs-indicator': {
      backgroundColor: '#27a9e0',
    },
    '& .MuiTab-textColorPrimary.Mui-selected': {
      color: '#27a9e0',
    },
  },
}))

const getReportingDataDateRange = async (startDate, endDate): Promise<void> => {
  let response

  try {
    response = await API.get(
      'mav-outlook-api',
      `/users/reports?startDate=${startDate}&endDate=${endDate}`,
      {},
    )
    return response
  } catch (e) {
    console.error(e)
    return e as void
  }
}

const override = css`
  display: block;
`

// const Days = ['1 DAY', '7 DAYS', '15 DAYS', '30 DAYS', '60 DAYS', '90 DAYS', 'CUSTOM']
const Status = ['All', 'Replied', 'Opened']
const NewReports = (props): JSX.Element => {
  const [isLoading, setLoading] = useState(true)
  // const [timeRange, setTimeRange] = useState('')
  const [reportingData, setReportingData] = useState<any>()
  const [tableData, setTableData] = useState<any>([])
  const [subscriptionData] = useState<any>()
  // const [currentDay, setCurrentDay] = useState(0)
  const [startDate, setStartDate] = useState(new Date().toISOString())
  const [endDate, setEndDate] = useState(new Date().toISOString())
  const [currentStatus, setCurrentStatus] = useState('All')
  const [currentType, setCurrentType] = useState('All')
  const [isActiveCompany, setIsActiveCompany] = useState(true)
  const [isActiveUser, setIsActiveUser] = useState(true)
  const [contactsSearch, onContactsSearchChange] = useState('')
  const { prospects, search, settings, setTypeProp, setCurrentUser } = props
  const classes = useStyles()

  const didMount = async (startDateVal, endDateVal): Promise<void> => {
    setLoading(true)
    try {
      const temp = await getReportingDataDateRange(startDateVal, endDateVal)
      setReportingData(temp)
      setLoading(false)
    } catch (e) {
      console.error(e)
      console.error('Reporting Data Error: ', JSON.stringify(e))
      setReportingData(undefined)
      setLoading(false)
    }
  }

  // const handleDayChange = (item): void => {
  //   const day = item.replace(' DAYS', '').replace(' DAY', '')
  // setCurrentDay(day)
  // setTimeRange(`${day}D`)
  // didMount(`${day}D`)
  // }

  const handleDateChange = (startDateVal, endDateVal): void => {
    console.log({
      functionName: handleDateChange,
      startDateVal,
      endDateVal,
    })
    setStartDate(startDateVal)
    setEndDate(endDateVal)
    didMount(startDateVal, endDateVal)
  }

  const handleStatusChange = (item): void => {
    setCurrentStatus(item)
  }

  const handleTypeChange = (item): void => {
    setCurrentType(item)
  }

  const exportHangar = async (results: Prospect[] | undefined): Promise<void> => {
    const myInit = { body: results }

    try {
      await API.post('mav-outlook-api', '/users/reports/export', myInit)
      search?.pushToToasts({
        type: ToastTypeEnum.INFO,
        message: 'Your report will be emailed to you shortly',
      })
    } catch (e) {
      console.error(e)
      prospects?.setIsLoading(false)
    }
  }

  const exportFullData = (): void => {
    if (tableData.length === 0) {
      search?.pushToToasts({
        type: ToastTypeEnum.WARNING,
        message: 'No datas for export!',
      })
    }
    let tempTableData = [...tableData]
    if (contactsSearch !== '') {
      tempTableData = tempTableData.filter(
        item =>
          item.Name.toLowerCase().includes(contactsSearch.toLowerCase()) ||
          item.Title.toLowerCase().includes(contactsSearch.toLowerCase()),
      )
    }
    if (currentStatus === 'Replied') {
      tempTableData = tempTableData.filter(item => item.Replied)
    } else if (currentStatus === 'Opened') {
      tempTableData = tempTableData.filter(item => item.Opened)
    }
    if (!isActiveUser) {
      tempTableData = tempTableData.filter(item => item['Added By'] !== 'User')
    }
    if (!isActiveCompany) {
      tempTableData = tempTableData.filter(item => item['Added By'] !== 'Maverick')
    }
    exportHangar(tempTableData)
  }

  useEffect(() => {
    didMount(new Date().toISOString(), new Date().toISOString())
  }, [])

  // Bulk Updates
  const [openActions, setOpenActions] = useState(false)
  const [selectedLeadsEmails, setselectedLeadsEmails] = useState<any>([])

  const renderKeyValues = (): JSX.Element => {
    return (
      <div>
        <div className={classes.root}>
          {reportingData && (
            <ReportEngagement
              addedProspects={reportingData.prospectsAdded.combined}
              sentEmails={reportingData.sentEmails.combined}
              replyData={reportingData.replyData.combined[1]?.value}
              openData={reportingData.openData?.combined?.reduce((a, b) => a + (b.opened || 0), 0)}
            />
          )}
          <Divider />
          <ReportFilters
            status={Status}
            handleStatusChange={handleStatusChange}
            currentStatus={currentStatus}
            handleTypeChange={handleTypeChange}
            currentType={currentType}
            isActiveCompany={isActiveCompany}
            setIsActiveCompany={setIsActiveCompany}
            isActiveUser={isActiveUser}
            setIsActiveUser={setIsActiveUser}
            contactsSearch={contactsSearch}
            onContactsSearchChange={onContactsSearchChange}
          />
          <Divider />
          <ReportActivity
            // handleDayChange={handleDayChange}
            handleDateChange={handleDateChange}
            // days={Days}
            startDate={startDate}
            endDate={endDate}
            setReportingData={setReportingData}
            exportFullData={exportFullData}
            isLoading={isLoading}
          />
          <Divider />
          {isLoading && (
            <BarLoader
              color="#27a9e0"
              loading={isLoading}
              speedMultiplier={1}
              height={4}
              css={override}
              width="100%"
            />
          )}
          {openActions ? (
            <div className="bulk-actions">
              <BulkLeadActions
                setIsLoading={setLoading}
                leadsToBeUpdated={selectedLeadsEmails}
                setOpenActions={setOpenActions}
                openActions={openActions}
                isEmailsOnly
                isLoading={isLoading}
              />
            </div>
          ) : null}
          {reportingData && (
            <Report
              title="TITLE"
              reportingData={reportingData}
              sentEmails={reportingData.sentEmails}
              replyData={reportingData.replyData}
              openData={reportingData.openData}
              recentData={reportingData.recentData}
              subscriptionData={subscriptionData}
              settings={settings}
              prospectsAdded={reportingData.prospectsAdded}
              currentType={currentType}
              setTypeProp={setTypeProp}
              setCurrentUser={setCurrentUser}
              currentStatus={currentStatus}
              isActiveCompany={isActiveCompany}
              isActiveUser={isActiveUser}
              contactsSearch={contactsSearch}
              tableData={tableData}
              setTableData={setTableData}
              setselectedLeadsEmails={setselectedLeadsEmails}
              setOpenActions={setOpenActions}
            />
          )}
        </div>
      </div>
    )
  }

  return (
    <div className="touches w-100 overflow-auto">
      <ListGroup>{renderKeyValues()}</ListGroup>
    </div>
  )
}

export default inject('prospects', 'search', 'settings')(observer(NewReports))
